// extracted by mini-css-extract-plugin
module.exports = {"navLink":"Navigation_navLink__2IANq","activeNavLink":"Navigation_activeNavLink__1X4vH"};